<template>
    <div class="oral-hygiene-experts-container" id="oral-hygiene-experts">
        <section class="container">
            <div class="row-custom">
                <div class="team-col">
                    <h1>Cosmetische Tandheelkunde</h1>
                    <p>
                        Een mooie lach kan een wereld van verschil maken. Bij Tandzorg Gestel bieden we diverse cosmetische behandelingen die uw glimlach net dat beetje extra geven. Denk hierbij aan tanden bleken voor een stralend wit gebit, facings om scheve of verkleurde tanden te corrigeren en kroonwerk voor een perfecte vorm en kleur. Wij werken altijd met hoogwaardige materialen en streven naar een natuurlijk resultaat, zodat u met zelfvertrouwen kunt lachen
                    </p>
                    <!-- <a href="" class="hero-btn red-btn">Steun ons</a> -->
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/angst-behandeling-foto.jpg" id="the-practice-img">
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "OralHygieneExperts",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}

#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
}

.oral-hygiene-experts-container {
    padding: 4rem 0;
}


@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }

}
</style>